export default __webpack_public_path__ + "static/media/formula-one.9ef37953.png";